import { Button, DialogActions, DialogContent, DialogTitle, Grid, Link, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { createAxios } from "../../common/axios";
import { renderClose } from "../../common/dialog";

export const OrderShipmentPaymentGatewayLinkDialog = (props: {
    close: () => void;
    shipment: {
        id: number;
        invcId: string;
        paymentGatewayLink: string;
    };
    onUpdated(data: { paymentGatewayLink: string }): void;
}) => {

    const [paymentGatewayLink, SetPaymentGatewayLink] = useState(null);
    const [canCreatePaymentLink, SetCanCreatePaymentLink] = useState(true);
    const [paymentLinkStatusText, SetPaymentLinkStatusText] = useState<string | null>();

    async function createPaymentLink() {
        try {
            const { data } = await createAxios().post(`customers/orderShipments/${props.shipment.id}/createPaymentLink`);
            SetPaymentGatewayLink(data.redirect);
            SetPaymentLinkStatusText(null);
            SetCanCreatePaymentLink(false);
            props.onUpdated({ paymentGatewayLink: data.redirect });
        } catch {
            return null;
        }
    }

    const initialized = useRef(false)

    useEffect(() => {
        const isPaymentLinkExpired = async () => {
            try {
                if (!initialized.current) {
                    initialized.current = true

                    const { data } = await createAxios().post(`customers/orderShipments/${props.shipment.id}/isPaymentLinkExpired`);

                    SetCanCreatePaymentLink(data.status !== 'PENDING');

                    if (data.status !== 'OK') {
                        SetPaymentLinkStatusText(`${data.status} ${data.paymentErrorReason ? '-' : ''} ${data.paymentErrorReason == null ? '' : data.paymentErrorReason}`);
                    }
                    else {
                        SetPaymentLinkStatusText(null);
                    }
                }
            } catch {
                return null;
            }
        }

        if (props.shipment.paymentGatewayLink) {
            isPaymentLinkExpired();
        }
        else {
            SetCanCreatePaymentLink(true);
        }
    }, [props.shipment.id, props.shipment.paymentGatewayLink]);

    return <>
        <DialogTitle>{`Create payment gateway link for invoice - ${props.shipment.invcId}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2}>
                <Grid item xs={12}><Link target="_blank" href={paymentGatewayLink ?? props.shipment.paymentGatewayLink} underline="always" rel="noreferrer">{paymentGatewayLink ?? props.shipment.paymentGatewayLink}</Link></Grid>
                {paymentLinkStatusText && <Grid item xs={12}><TextField value={paymentLinkStatusText} label="Payment link state" InputProps={{ disabled: true }} /></Grid>}
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={createPaymentLink} disabled={!canCreatePaymentLink}>Create payment link</Button>
        </DialogActions>
    </>;
};